import React from 'react';
import { Icon, Tooltip } from 'antd';
import { CardIconButton } from '../../../../../components/Card';
import styles from './Documents.module.scss';

const renderIcon = ({ attachment }) => {
  const { availableForClient, fromDate } = attachment || {};

  if (!availableForClient) {
    return (
      <Tooltip title="Не показывается собственнику" placement="bottomRight">
        <Icon type="eye-invisible" className={styles.eyeIcon} />
      </Tooltip>
    );
  } else if (!fromDate) {
    return (
      <Tooltip title="Показывается собственнику" placement="bottomRight">
        <Icon type="eye" className={styles.eyeIcon} />
      </Tooltip>
    );
  } else {
    return null;
  }
};

const Actions = ({ attachment, onEditClick }) => {
  return (
    <>
      {renderIcon({ attachment })}
      {typeof onEditClick === 'function' && (
        <Tooltip title="Изменить" placement="bottomRight">
          <CardIconButton
            onClick={() => {
              onEditClick(attachment);
            }}
            renderIcon={() => <Icon type="edit" />}
          />
        </Tooltip>
      )}
    </>
  );
};

export default Actions;
